export enum PenaltyGetActionTypes {
    REQUEST = '@@penalty/get/request',
    SUCCESS = '@@penalty/get/success',
    ERROR = '@@penalty/get/error',
    CLEAR = '@@penalty/get/clear'
}

export enum PenaltyPayActionTypes {
    REQUEST = '@@penalty/pay/request',
    SUCCESS = '@@penalty/pay/success',
    ERROR = '@@penalty/pay/error'
}
